import { api } from "@api/api";
import { Catalog } from "@modules/catalogs/types";
import { CatalogFormValues } from "@modules/catalogs/validations";

export async function createCatalogService(data: CatalogFormValues): Promise<Catalog> {
  const { data: catalog } = await api.post<Catalog>("v1/plan_admin/", data);

  return catalog;
}
